import type { IConfig } from '@unleash/proxy-client-vue'
import { plugin as unleashPlugin } from '@unleash/proxy-client-vue'
import { defu } from 'defu'

declare module 'nuxt/schema' {
  interface RuntimePublicConfig {
    unleash?: Partial<IConfig>
  }
}

export default defineNuxtPlugin(nuxt => {
  const { unleash } = useRuntimeConfig().public

  const config = defu<IConfig, Partial<IConfig>[]>(unleash, {
    environment: import.meta.env.MODE,
    refreshInterval: 0,
    disableMetrics: true,
  })

  nuxt.vueApp.use(unleashPlugin, {
    config,
  })
})
